import { render, staticRenderFns } from "./VentTotalRapp.vue?vue&type=template&id=3f2c80b6&scoped=true&"
import script from "./VentTotalRapp.vue?vue&type=script&lang=js&"
export * from "./VentTotalRapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2c80b6",
  null
  
)

export default component.exports